<div class="ux-debug-launcher" *ngIf="debugEnabled">
  <button type="button" class="ux-debug-toggle" (click)="togglePanel()">
    {{ showPanel ? 'Hide debug' : 'Show debug' }}
  </button>
</div>

<aside class="ux-debug-panel" *ngIf="debugEnabled && showPanel">
  <div class="ux-debug-panel__header">
    <strong>Dev mock tools</strong>
    <button type="button" class="ux-debug-close" (click)="togglePanel()">×</button>
  </div>

  <div class="ux-debug-row">
    <label for="debug-source">Source</label>
    <select
      id="debug-source"
      [value]="state.useRealApi ? 'real' : 'mock'"
      (change)="($any($event.target).value === 'real') ? useRealApi() : useMockScenario(state.scenarioId)"
    >
      <option value="real">Real API</option>
      <option value="mock">Mock scenario</option>
    </select>
  </div>

  <div class="ux-debug-row">
    <label for="debug-scenario">Scenario</label>
    <select
      id="debug-scenario"
      [disabled]="state.useRealApi"
      [value]="state.scenarioId"
      (change)="useMockScenario($any($event.target).value)"
    >
      <option *ngFor="let scenario of scenarios" [value]="scenario.id">
        {{ scenario.label }}
      </option>
    </select>
  </div>

  <div class="ux-debug-row">
    <label for="debug-latency">Latency (ms)</label>
    <input
      id="debug-latency"
      type="number"
      min="0"
      step="250"
      [value]="state.latencyMs"
      (input)="updateLatency($any($event.target).value)"
    />
  </div>

  <p class="ux-debug-description" *ngIf="!state.useRealApi">
    {{ mockScenarioService.activeScenario.description }}
  </p>

  <div class="ux-debug-actions">
    <button type="button" class="ux-debug-secondary" (click)="reset()">Reset</button>
  </div>
</aside>
